import React, { useContext, useState, useEffect } from 'react';
import { AbilityContext } from './AbilityContext';
import UnauthorizedAccessPage from './UnautherisedUI';
import { Grid, CircularProgress } from '@mui/material'
import CampaignPendingUI from './organisations/CampaignPendingUI';
import { useSelector } from 'react-redux';
import { useMatch } from 'react-router';

const ProtectedRoute = ({ action, subject, children }) => {
  const ability = useContext(AbilityContext);
  const roleInfo = useSelector((state) => state?.user?.role);
  const currentOrganization = useSelector((state) => state?.user?.organization);

  const authUserStatus = roleInfo?.app_status;
  const orgStatus = currentOrganization?.app_status;
  const orgIdInstore = currentOrganization?.documentId;
  let orgId = '';

  const match = useMatch('/org/:orgId/*');
  if (match) {
    orgId = match?.params?.orgId;
  };

  if (orgIdInstore != orgId) {
    return <CircularProgress />
  }

  const hasPermission = ability?.can(action, subject);
  const isAccessible =
    hasPermission && orgStatus === 'active' && authUserStatus === 'active'
      ? hasPermission
      : orgStatus === 'inactive'
        ? null
        : false;

  if (isAccessible === null) {
    return orgStatus === 'inactive'
      ? <CampaignPendingUI />
      : <Grid xs="12" sx={{ textAlign: "center" }}>
        <CircularProgress />
      </Grid>;
  }

  return isAccessible ? children : <UnauthorizedAccessPage />;
};

export default ProtectedRoute;
